import React from 'react'

import CollapsibleSection from '_components/collapsible-section/index.jsx'
import { useEventFeedsContext } from '../../../context/index.jsx'

const S3AccessKeys = ({}) => {
  const {
    data: { deliveries },
  } = useEventFeedsContext()
  const delivery = deliveries[0] ?? {}

  if (delivery.destination != 'sharethis-s3' || !delivery.name || !delivery.s3AccessKeys)
    return null

  let keys = null
  delivery.s3AccessKeys.forEach((_keys) => {
    if (_keys.name == delivery.name && _keys.accessKey) {
      keys = _keys
    }
  })

  if (!keys) {
    return null
  }

  return (
    <div className="delivery-content__content-section">
      <CollapsibleSection
        title={<h3 className="delivery-content__content-title">S3 Access Keys</h3>}
      >
        <div>
          <span className="delivery-content__content-label">Access Key:</span>
          <span className="delivery-content__content-key">{keys.accessKey}</span>
          <span className="delivery-content__content-label">Secret Access Key:</span>
          <span className="delivery-content__content-key">{keys.secretAccessKey}</span>
        </div>
      </CollapsibleSection>
    </div>
  )
}

export default S3AccessKeys
